import * as yup from 'yup';
import { array, InferType } from 'yup';
import { strings } from 'strings';

export const puzzleSchema = yup.object({
  puzzleId: yup.string().required(),
  name: yup.string().required(),
  icon: yup.string().required(),
});

export const gameEventLevelFormSchema = yup.object({
  id: yup.string().optional(),

  level: yup.number().required(strings.gameEvent.form.errors.level.required),

  reward: yup
    .number()
    .typeError(strings.gameEvent.form.errors.reward.type)
    .min(0, strings.gameEvent.form.errors.reward.min)
    .required(strings.gameEvent.form.errors.reward.required),

  difficulty: yup
    .object({
      label: yup.string(),
      value: yup.number().required(strings.gameEvent.form.errors.difficulty.required),
    })
    .typeError(strings.gameEvent.form.errors.difficulty.type)
    .required(strings.gameEvent.form.errors.difficulty.required),

  puzzles: array()
    .of(puzzleSchema)
    .min(1, strings.gameEvent.form.errors.puzzles.min)
    .test('unique-puzzle-id', strings.gameEvent.form.errors.puzzles.unique, (puzzles) => {
      if (!puzzles) {
        return true;
      }

      const puzzleIds = puzzles.map((puzzle) => puzzle.puzzleId as string);
      const uniquePuzzleIds = [...Array.from(new Set(puzzleIds))];
      return uniquePuzzleIds.length === puzzleIds.length;
    })
    .required(strings.gameEvent.form.errors.puzzles.required),
});

export type GameEventLevelField = InferType<typeof gameEventLevelFormSchema>;
